export default [
  {
    path: '/masters',
    name: 'masters',
    component: () => import(/* webpackChunkName: "master" */ '@/view/master/index.vue'),
    meta: { auth: true },
    children: [
      {
        path: 'satuan-kpi',
        name: 'master-satuan-kpi',
        component: () => import(/* webpackChunkName: "satuan-kpi" */ '@/view/master/satuan-kpi/index.vue'),
      },
      {
        path: 'satuan-kpi-add',
        name: 'master-satuan-kpi-add',
        component: () => import(/* webpackChunkName: "satuan-kpi-add" */ '@/view/master/satuan-kpi/add.vue'),
      },
      {
        path: 'satuan-kpi-edit/:id',
        name: 'master-satuan-kpi-edit',
        component: () => import(/* webpackChunkName: "satuan-kpi-edit" */ '@/view/master/satuan-kpi/edit.vue'),
      },
      {
        path: 'jenis-variable-kpi',
        name: 'master-jenis-variable-kpi',
        component: () =>
          import(/* webpackChunkName: "jenis-variable-kpi" */ '@/view/master/jenis-variable-kpi/index.vue'),
      },
      {
        path: 'jenis-variable-kpi-add',
        name: 'master-jenis-variable-kpi-add',
        component: () =>
          import(/* webpackChunkName: "jenis-variable-kpi-add" */ '@/view/master/jenis-variable-kpi/add.vue'),
      },
      {
        path: 'jenis-variable-kpi-edit/:id',
        name: 'master-jenis-variable-kpi-edit',
        component: () =>
          import(/* webpackChunkName: "jenis-variable-kpi-edit" */ '@/view/master/jenis-variable-kpi/edit.vue'),
      },
      {
        path: 'direktorat',
        name: 'master-direktorat',
        component: () => import(/* webpackChunkName: "direktorat" */ '@/view/master/direktorat/index.vue'),
      },
      {
        path: 'direktorat-add',
        name: 'master-direktorat-add',
        component: () => import(/* webpackChunkName: "direktorat-add" */ '@/view/master/direktorat/add.vue'),
      },
      {
        path: 'direktorat-edit/:id',
        name: 'master-direktorat-edit',
        component: () => import(/* webpackChunkName: "direktorat-edit" */ '@/view/master/direktorat/edit.vue'),
      },
      {
        path: 'perusahaan',
        name: 'master-perusahaan',
        component: () => import(/* webpackChunkName: "perusahaan" */ '@/view/master/perusahaan/index.vue'),
      },
      {
        path: 'perusahaan-add',
        name: 'master-perusahaan-add',
        component: () => import(/* webpackChunkName: "perusahaan-add" */ '@/view/master/perusahaan/add.vue'),
      },
      {
        path: 'perusahaan-edit/:id',
        name: 'master-perusahaan-edit',
        component: () => import(/* webpackChunkName: "perusahaan-edit" */ '@/view/master/perusahaan/edit.vue'),
      },
      {
        path: 'bidang-usaha',
        name: 'master-bidang-usaha',
        component: () => import(/* webpackChunkName: "bidang-usaha" */ '@/view/master/bidang-usaha/index.vue'),
      },
      {
        path: 'bidang-usaha-add',
        name: 'master-bidang-usaha-add',
        component: () => import(/* webpackChunkName: "bidang-usaha-add" */ '@/view/master/bidang-usaha/add.vue'),
      },
      {
        path: 'bidang-usaha-edit/:id',
        name: 'master-bidang-usaha-edit',
        component: () => import(/* webpackChunkName: "bidang-usaha-edit" */ '@/view/master/bidang-usaha/edit.vue'),
      },
      {
        path: 'pltu',
        name: 'master-pltu',
        component: () => import(/* webpackChunkName: "pltu" */ '@/view/master/pltu/index.vue'),
      },
      {
        path: 'pltu-add',
        name: 'master-pltu-add',
        component: () => import(/* webpackChunkName: "pltu-add" */ '@/view/master/pltu/add.vue'),
      },
      {
        path: 'pltu-edit/:id',
        name: 'master-pltu-edit',
        component: () => import(/* webpackChunkName: "pltu-edit" */ '@/view/master/pltu/edit.vue'),
      },
      {
        path: 'user',
        name: 'master-user',
        component: () => import(/* webpackChunkName: "user" */ '@/view/master/user/index.vue'),
        meta: { auth: true },
      },
      {
        path: 'user-add',
        name: 'master-user-add',
        component: () => import(/* webpackChunkName: "user-add" */ '@/view/master/user/add.vue'),
      },
      {
        path: 'user-edit/:id',
        name: 'master-user-edit',
        component: () => import(/* webpackChunkName: "user-edit" */ '@/view/master/user/edit.vue'),
      },
      {
        path: 'role',
        name: 'master-role',
        component: () => import(/* webpackChunkName: "role" */ '@/view/master/role/index.vue'),
      },
      {
        path: 'role-add',
        name: 'master-role-add',
        component: () => import(/* webpackChunkName: "role-add" */ '@/view/master/role/add.vue'),
      },
      {
        path: 'role-edit/:id',
        name: 'master-role-edit',
        component: () => import(/* webpackChunkName: "role-edit" */ '@/view/master/role/edit.vue'),
      },
      {
        path: 'permission',
        name: 'master-permission',
        component: () => import(/* webpackChunkName: "permission" */ '@/view/master/permission/index.vue'),
      },
      {
        path: 'permission-add',
        name: 'master-permission-add',
        component: () => import(/* webpackChunkName: "permission-add" */ '@/view/master/permission/add.vue'),
      },
      {
        path: 'permission-edit/:id',
        name: 'master-permission-edit',
        component: () => import(/* webpackChunkName: "permission-edit" */ '@/view/master/permission/edit.vue'),
      },
      {
        path: 'pegawai',
        name: 'master-pegawai',
        component: () => import(/* webpackChunkName: "pegawai" */ '@/view/master/pegawai/index.vue'),
      },
      {
        path: 'pegawai-add',
        name: 'master-pegawai-add',
        component: () => import(/* webpackChunkName: "pegawai-add" */ '@/view/master/pegawai/add.vue'),
      },
      {
        path: 'pegawai-edit/:id',
        name: 'master-pegawai-edit',
        component: () => import(/* webpackChunkName: "pegawai-edit" */ '@/view/master/pegawai/edit.vue'),
      },
      {
        path: 'pegawai-import',
        name: 'master-pegawai-import',
        component: () => import(/* webpackChunkName: "pegawai-import" */ '@/view/master/pegawai/import.vue'),
      },
      {
        path: 'vendor',
        name: 'master-vendor',
        component: () => import(/* webpackChunkName: "vendor" */ '@/view/master/vendor/index.vue'),
      },
      {
        path: 'vendor-add',
        name: 'master-vendor-add',
        component: () => import(/* webpackChunkName: "vendor-add" */ '@/view/master/vendor/add.vue'),
      },
      {
        path: 'vendor-edit/:id',
        name: 'master-vendor-edit',
        component: () => import(/* webpackChunkName: "vendor-edit" */ '@/view/master/vendor/edit.vue'),
      },
      {
        path: 'vendor-import',
        name: 'master-vendor-import',
        component: () => import(/* webpackChunkName: "vendor-import" */ '@/view/master/vendor/import.vue'),
      },
      {
        path: 'divisi-bidang',
        name: 'master-divisi-bidang',
        component: () => import(/* webpackChunkName: "divisi-bidang" */ '@/view/master/divisi-bidang/index.vue'),
      },
      {
        path: 'divisi-bidang-add',
        name: 'master-divisi-bidang-add',
        component: () => import(/* webpackChunkName: "divisi-bidang-add" */ '@/view/master/divisi-bidang/add.vue'),
      },
      {
        path: 'divisi-bidang-edit/:id',
        name: 'master-divisi-bidang-edit',
        component: () => import(/* webpackChunkName: "divisi-bidang-edit" */ '@/view/master/divisi-bidang/edit.vue'),
      },
      {
        path: 'bidang',
        name: 'master-bidang',
        component: () => import(/* webpackChunkName: "bidang" */ '@/view/master/bidang/index.vue'),
      },
      {
        path: 'bidang-add',
        name: 'master-bidang-add',
        component: () => import(/* webpackChunkName: "bidang-add" */ '@/view/master/bidang/add.vue'),
      },
      {
        path: 'bidang-edit/:id',
        name: 'master-bidang-edit',
        component: () => import(/* webpackChunkName: "bidang-edit" */ '@/view/master/bidang/edit.vue'),
      },
      {
        path: 'entitas',
        name: 'master-entitas',
        component: () => import(/* webpackChunkName: "entitas" */ '@/view/master/entitas/index.vue'),
      },
      {
        path: 'entitas-add',
        name: 'master-entitas-add',
        component: () => import(/* webpackChunkName: "entitas-add" */ '@/view/master/entitas/add.vue'),
      },
      {
        path: 'entitas-edit/:id',
        name: 'master-entitas-edit',
        component: () => import(/* webpackChunkName: "entitas-edit" */ '@/view/master/entitas/edit.vue'),
      },
    ],
  },
];
